package br.com.texeratx.boardgametimeapp.ui.screens.home

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.MoreVert
import androidx.compose.material3.BottomAppBar
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.i18n.LocalStrings
import br.com.texeratx.boardgametimeapp.ui.components.dashboard.StartMatchFab
import br.com.texeratx.boardgametimeapp.ui.components.icon.GamesIcon
import br.com.texeratx.boardgametimeapp.ui.components.icon.MatchesIcon
import br.com.texeratx.boardgametimeapp.ui.components.icon.PlayersIcon

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun HomeBottomBar(
    onGames: () -> Unit,
    onPlayers: () -> Unit,
    onStartMatch: () -> Unit,
    onMatches: () -> Unit,
    onExpansions: () -> Unit,
    onOptions: () -> Unit,
    onStats: () -> Unit,
    onClan: () -> Unit,
) {
    val S = LocalStrings.current
    var menuExpanded by remember { mutableStateOf(false) }

    Surface(
        tonalElevation = 3.dp,
        shadowElevation = 0.dp,
        color = MaterialTheme.colorScheme.surface
    ) {
        BottomAppBar(
            containerColor = MaterialTheme.colorScheme.surface,
            tonalElevation = 0.dp,
            modifier = Modifier.fillMaxWidth()
        ) {
            BottomItem(label = S.navGames, onClick = onGames) { GamesIcon() }
            BottomItem(label = S.navPlayers, onClick = onPlayers) { PlayersIcon() }

            Box(modifier = Modifier.weight(1f), contentAlignment = Alignment.Center) {
                StartMatchFab(onClick = onStartMatch)
            }

            BottomItem(label = S.navMatches, onClick = onMatches) { MatchesIcon() }

            Box(modifier = Modifier.weight(1f), contentAlignment = Alignment.Center) {
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(2.dp)
                ) {
                    IconButton(onClick = { menuExpanded = true }) {
                        Icon(
                            imageVector = Icons.Default.MoreVert,
                            contentDescription = S.navMenu,
                            tint = MaterialTheme.colorScheme.onSurfaceVariant,
                            modifier = Modifier.size(22.dp)
                        )
                    }
                    Text(
                        text = S.navMenu,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        style = MaterialTheme.typography.labelSmall,
                        fontWeight = FontWeight.SemiBold
                    )
                }

                DropdownMenu(
                    expanded = menuExpanded,
                    onDismissRequest = { menuExpanded = false }
                ) {
                    DropdownMenuItem(text = { Text(S.menuClan) }, onClick = { menuExpanded = false; onClan() })
                    DropdownMenuItem(text = { Text(S.menuStats) }, onClick = { menuExpanded = false; onStats() })
                    DropdownMenuItem(text = { Text(S.menuExpansions) }, onClick = { menuExpanded = false; onExpansions() })
                    DropdownMenuItem(text = { Text(S.menuOptions) }, onClick = { menuExpanded = false; onOptions() })
                }
            }
        }
    }
}

@Composable
private fun RowScope.BottomItem(
    label: String,
    onClick: () -> Unit,
    icon: @Composable () -> Unit
) {
    Box(
        modifier = Modifier.weight(1f),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(2.dp)
        ) {
            IconButton(onClick = onClick) {
                Box(Modifier.size(48.dp), contentAlignment = Alignment.Center) {
                    icon()
                }
            }
            Text(
                text = label,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                style = MaterialTheme.typography.labelSmall,
                fontWeight = FontWeight.SemiBold
            )
        }
    }
}
